import React, { useCallback, useRef, useState } from 'react';
// import { GAME } from "./data";
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js';
import VietnameseFont1 from './item/vietnameseFont1.json';
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js';
import { useFrame } from '@react-three/fiber';

function Answer({
  text,
  index,
  correctkey,
  parent,
  textSpace,
  planeSpace,
  space,
  answerAspect,
  isActive,
  onClick,
}) {
  const loader = new FontLoader();
  const font = loader.parse(VietnameseFont1);
  const textRef = useRef();
  const planeMaterialRef = useRef();
  const planeRef = useRef();
  // eslint-disable-next-line
  const [activeDiv, setActiveDiv] = useState(null);

  const geometry = new TextGeometry(text, {
    font: font,
    size: 10,
    height: 0.5,
    depth: 1,
    curveSegments: 4,
    bevelThickness: 1,
    bevelSize: 0,
    bevelEnabled: true,
  });
  geometry.computeBoundingBox();
  const centerOffset =
    0.5 * (parent.boundingBox.max.x - parent.boundingBox.min.x);
  const centerOffsetY =
    0.5 * (parent.boundingBox.max.y - parent.boundingBox.min.y);

  const onPointerEnter = useCallback(() => {
    document.body.style.cursor = 'pointer';
  }, []);

  const onPointerLeave = useCallback(() => {
    document.body.style.cursor = 'default';
  }, []);

  useFrame(({ state, clock, gl, camera }) => {
    if (planeRef.current) {
      const time = clock.getElapsedTime();
      const percent = (1 + Math.sin(time * 2)) / 2;
      const opacity = 0.5 + 1 * percent;

      planeMaterialRef.current.opacity = opacity;
    }
  });

  console.log(index);

  console.log(activeDiv);

  return (
    <group position={[0, -centerOffsetY, 0]}>
      <mesh
        ref={textRef}
        position={[-centerOffset, textSpace - space * index, 0]}
      >
        <primitive object={geometry} />
        <meshBasicMaterial color={'black'} />
      </mesh>
      <mesh
        ref={planeRef}
        position={[0, planeSpace - space * index, 0]}
        onPointerEnter={onPointerEnter}
        onPointerLeave={onPointerLeave}
        onClick={() => onClick(index)}
      >
        <planeGeometry args={[answerAspect.width, answerAspect.height]} />
        <meshBasicMaterial
          ref={planeMaterialRef}
          transparent
          alphaTest={0.5}
          color={`${isActive ? 'coral' : 'white'}`}
        />
      </mesh>
    </group>
  );
}

export default Answer;
